module.exports = __webpack_public_path__ + "img/6.b35b2a65.jpg";